import React from 'react';
import { pdfFiles } from '../../body/Pdf';
import { VideoAndShowPDFAfter } from '../../body/VideoSlide';

const ReducingStress = () => {
  const takeFivePdf = pdfFiles.strategiesPart2.find(
    (pdf) => pdf.name === 'Take 5 Breathing Exercise',
  );
  const mindJarPdf = pdfFiles.strategiesPart2.find(
    (pdf) => pdf.name === 'Mind Jar',
  );

  return (
    <div className='text-left p-4 space-y-6'>
      <VideoAndShowPDFAfter
        pdfFile={[takeFivePdf, mindJarPdf]}
        vidSrc={1194425988}
      />
    </div>
  );
};

export default ReducingStress;
